/**
 * @mixin insuranceCardFieldsMixin
 * @description Assembles an array of sections.
 * It takes into consideration the maximum length that the layout will be able to render per section.
 * The maximum length per section can be set in lengthPerSection property data.
 * @results {array} of sections with insurance dinamyc fields.
 * @see lengthPerSection
 */
export default {
  name: 'insuranceCardFieldsMixin',

  data() {
    return {
      lengthPerSection: 30,
      sections: [],
      loopFieldQuestions: [],
      loopFieldAnswers: [],
      loopFields: [],
    };
  },

  computed: {
    /**
     * @property dynamicSections
     * @description Instanciate an array with sections (lines) for HealthInsuranceCard component
     * @returns {array} A section object containing it's status and all inner items
     */
    dynamicSections() {
      return this.sections.map(section => {
        return {
          active: true,
          items: section,
        };
      });
    },
    dynamicFields() {
      return this.cardDetails.insuranceFields;
    },
  },

  watch: {
    dynamicFields() {
      this.getDynamicSectionsFields();
    }
  },

  methods: {
    /**
     * @function getDynamicSectionsFields()
     * @description Loops through dynamicFields() to return insurance card sections.
     * It validates each question/anwser to guarantee it will render properly following the giving design.
     * @see sections
     * @see addNewField()
     * @see currentSectionAllowNewContent()
     * @see clearFields()
     */
    getDynamicSectionsFields() {
      this.dynamicFields.forEach((item, i) => {
        const sectionAllowNewContent = this.currentSectionAllowNewContent(item);
        const endOfLoop = (i + 1) === this.dynamicFields.length;

        if (sectionAllowNewContent) {
          this.addNewField(item);
        } else {
          this.sections.push(this.loopFields);
          this.clearFields();
          this.addNewField(item);
        }

        if (endOfLoop) {
          this.sections.push(this.loopFields);
        }
      });
    },

    /**
     * @function currentSectionAllowNewContent()
     * @description Helper of getDynamicSectionsFields().
     * @param {object} Field containing answer and question
     * @returns {boolean} Validation to check if the current section still has enough space
     * @see getDynamicSectionsFields()
     */
    currentSectionAllowNewContent(field) {
      const allowNewQuestion = this.getSectionQuestionsLength(field) <= this.lengthPerSection;
      const allowNewAnswer = this.getSectionAnswersLength(field) <= this.lengthPerSection;

      return allowNewQuestion && allowNewAnswer;
    },

    /**
     * @function getSectionAnswersLength()
     * @description Helper of getDynamicSectionsFields().
     * @param {object} Awswer field
     * @returns {int} The total length of previous field length plus the current field length.
     * @see getDynamicSectionsFields()
     */
    getSectionAnswersLength(field) {
      const currentAnswer = field.answer.content.length;
      const previousAnswer = this.getFieldLength(this.loopFieldAnswers);

      return currentAnswer + previousAnswer;
    },

    /**
     * @function getSectionQuestionsLength()
     * @description Helper of getDynamicSectionsFields().
     * @param {object} Question field
     * @returns {int} The total length of previous field length plus the current field length.
     * @see getDynamicSectionsFields()
     */
    getSectionQuestionsLength(field) {
      const currentQuestion = field.question.content.length;
      const previousQuestion = this.getFieldLength(this.loopFieldQuestions);

      return currentQuestion + previousQuestion;
    },

    getFieldLength(item) {
      return item.join().replace(',', '').length;
    },

    addNewField(field) {
      this.loopFields.push(field);
      this.loopFieldQuestions.push(field.question.content);
      this.loopFieldAnswers.push(field.answer.content);
    },

    clearFields() {
      this.loopFields = [];
      this.loopFieldQuestions = [];
      this.loopFieldAnswers = [];
    }
  }
};
